"use strict";
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToPlatformId = exports.isValidPlatform = exports.PlatformId = void 0;
/**
 * An identifier unique to each Platform
 * Origins: https://confluence.atg-corp.com/display/~rickk/Introducing+platformid
 */
var PlatformId;
(function (PlatformId) {
    PlatformId["streamate"] = "streamate";
    PlatformId["streamfans"] = "streamfans";
    PlatformId["cambuilder"] = "cambuilder";
    PlatformId["creator"] = "creator";
    PlatformId["blacklabel"] = "blacklabel";
    PlatformId["adminpro"] = "adminpro";
    PlatformId["kwiky"] = "kwiky";
    PlatformId["legal"] = "legal";
})(PlatformId = exports.PlatformId || (exports.PlatformId = {}));
const PLATFORMID_TO_ENUM = new Map([
    ["streamate", PlatformId.streamate],
    ["streamfans", PlatformId.streamfans],
    ["cambuilder", PlatformId.cambuilder],
    ["creator", PlatformId.creator],
    ["blacklabel", PlatformId.blacklabel],
    ["adminpro", PlatformId.adminpro],
    ["kwiky", PlatformId.kwiky],
    ["legal", PlatformId.legal],
]);
/**
 * Checks whether a given string is a valid platform identifier
 * @param platformId the string to check
 * @returns `true` if the string is a valid platform identifier, `false` if not
 */
const isValidPlatform = (platformId) => PLATFORMID_TO_ENUM.has(platformId);
exports.isValidPlatform = isValidPlatform;
/**
 * Type conversion utility function that converts a `string` to a `PlatformId` enum typed value
 * @param platformId the string to convert
 * @returns a `PlatformId` enum value or `undefined` if the given input was not a valid platform identifier
 */
const stringToPlatformId = (platformId) => PLATFORMID_TO_ENUM.get(platformId);
exports.stringToPlatformId = stringToPlatformId;
